import { useMemo } from 'react';

import { useIsAskMeAnythingEnabled, useIsOnlineMeetingEnabled, useIsQuestionsOnlyMode } from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useAskMeAnythingEventCreationPageSettings: UseMainUIFeatureSettings<'askMeAnythingEventCreationPage'> = (
  options
) => {
  const askMeAnythingEventCreationPageOverrides = options?.overrides?.askMeAnythingEventCreationPage;

  const isAMAEnabled = useIsAskMeAnythingEnabled();
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();
  const isOnlineMeetingEnabled = useIsOnlineMeetingEnabled();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        [uiFeatureAccessSymbol]: false,
        onlineMeetingToggleEnabled: isOnlineMeetingEnabled,
        ...askMeAnythingEventCreationPageOverrides,
      };
    }

    return {
      [uiFeatureAccessSymbol]: isAMAEnabled,
      onlineMeetingToggleEnabled: isOnlineMeetingEnabled,
      ...askMeAnythingEventCreationPageOverrides,
    };
  }, [askMeAnythingEventCreationPageOverrides, isAMAEnabled, isQuestionsOnlyMode, isOnlineMeetingEnabled]);
};
